import React, { Component } from 'react';
import { Redirect, Link } from "react-router-dom";
import {
    Layout,
    Icon,
    Tooltip,
    Row,
    Col,
    Button,
    Divider,
    Input,
    Spin
} from 'antd';
import './layout.css';
import DashMenu from './Menu';
import { Provider, Translate, Translator } from 'react-translated';
import translation from './lang/translation';
import axios from './api';
import { getNameInitials } from './utils/Constants';

const { Header, Sider, Content, Footer } = Layout;

window.translate_db = translation;
window.translate_lang = "en";
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class DashLayout extends Component {
    state = {
        logout: false,
        collapsed: false,
        search: '',
        showSearch: false,
        agencyOwnerDetails: null,
        loading: true
    }
    componentDidMount() {
        if (this.props.isExternalBfile) {
            this.get_agency_owner_details();
        }
    }


    get_agency_owner_details = async () => {
        try {
            const response = await axios.get(`/api/get_agency_owner_details/external_rac?user_id=${this.props.extUserId}`);
            this.setState({
                agencyOwnerDetails: response.data,
                loading: false,
            });
        } catch (error) {
            this.setState({
                loading: false,
            });
        }
    };


    logout = () => {
        this.props.logout((result) => {
            if (result.success) {
                this.setState({
                    logout: true
                })
            }
        })
    }
    onCollapse = (collapsed) => {
        this.setState({ collapsed });
    }
    handleClick = (e) => {
        this.setState({
            selected_key: e.keyPath
        })
    }
    goTo = (path) => {
        this.props.history.push(path);
    }
    updateLang = (lang) => {
        this.setState({ lang })
    }
    search = () => {
        this.setState({
            showSearch: false
        }, () => {
            if (this.state.search !== '') {
                this.props.history.push('/search/' + this.state.search);
            }
        })
    }
    render() {

        const { logout, lang, loading, agencyOwnerDetails } = this.state;
        let user = this.props.auth.user;
        if (logout) {
            return <Redirect to={"/login"} />;
        }

        const selected_key = this.props.menu;
        const component = this.props.component;
        const isExternalBFile = this.props.isExternalBfile;

        const extAgencyId = this.props.extAgencyId;
        const extUserId = this.props.extUserId;
        const extWizardId = this.props.extWizardId;

        if (typeof user.language !== "undefined") {
            if (user.language === null || user.language === "") {
                user.language = "en";
            }
        } else {
            user.language = "en";
        }

        window.translate_lang = user.language;

        return (
            <Provider language={user.language} translation={translation}>
                <Layout style={{ minHeight: '100vh', overflowX: 'clip' }}>
                    <Layout>
                        {/* <Header style={{ background: '#fff', padding: 0 }}>
                            <div className="logo logo-b" />
                        </Header> */}
                        <Spin indicator={antIcon} spinning={loading}>
                            {
                                agencyOwnerDetails && (
                                    <Header style={{ background: '#fff', padding: '10px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', }}>
                                        <div className='agent-container'>
                                            {
                                                agencyOwnerDetails.agency_owner_details.agency_photo_url ? (
                                                    <img
                                                        src={agencyOwnerDetails.agency_owner_details.agency_photo_url}
                                                        alt="Agent"
                                                        style={{ borderRadius: '50%', height: '35px', marginRight: '10px' }}
                                                    />
                                                ) : (
                                                    <span
                                                        // style={{ borderRadius: '50%', height: '35px', marginRight: '10px' }}
                                                        style={{ marginRight: 10, color: "rgb(22, 72, 151)", background: '#F0F2F5', borderRadius: "50%", padding: "5px", fontWeight: "600", fontFamily: "Poppins" }}
                                                    >
                                                        {getNameInitials(`${agencyOwnerDetails.agency_owner_details.agency_name}`)}
                                                    </span>
                                                )
                                            }
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <h3 className='fs-agent-name' style={{ marginTop: "8px", marginBottom: '0px' }}>
                                                    {agencyOwnerDetails.agency_owner_details.agency_name}
                                                </h3>
                                                <a className='fs-agent-address'>
                                                    {agencyOwnerDetails.agency_owner_details.address}
                                                </a>
                                            </div>

                                        </div>

                                        {/* Right Section: Agent Name and Picture */}
                                        <div className='agent-container'>
                                            {
                                                agencyOwnerDetails.dp_url_curr_user ? (
                                                    <img
                                                        src={agencyOwnerDetails.dp_url_curr_user || "https://api.dicebear.com/7.x/miniavs/svg?seed=1"}
                                                        alt="Agent"
                                                        style={{ borderRadius: '50%', height: '35px' }}
                                                    />
                                                ) : (
                                                    <span
                                                        // style={{ borderRadius: '50%', height: '35px', marginRight: '10px' }}
                                                        style={{ marginRight: 10, color: "rgb(22, 72, 151)", background: '#F0F2F5', borderRadius: "50%", padding: "5px", fontWeight: "600", fontFamily: "Poppins" }}
                                                    >
                                                        {getNameInitials(`${agencyOwnerDetails.agency_owner_details.first_name} ${agencyOwnerDetails.agency_owner_details.last_name}`)}
                                                    </span>
                                                )
                                            }
                                            <span
                                                className='fs-agent-name' style={{ color: "black", padding: "0px 5px" }}>{agencyOwnerDetails.agency_owner_details.first_name} {agencyOwnerDetails.agency_owner_details.last_name}
                                            </span>
                                        </div>
                                    </Header>
                                )
                            }

                        </Spin>


                        <Content style={{ margin: '12px 8px', padding: 14, minHeight: 280 }}>
                            {React.cloneElement(component, { isExternalBFile, extAgencyId, extUserId, extWizardId })}
                        </Content>

                        {/* <Footer style={{ textAlign: 'center' }}>
                            © 2022 PersistEplan Software, LLC - B File is a registered trade mark of PersistEplan Software, LLC (patent pending)
                        </Footer> */}
                    </Layout>
                </Layout>
            </Provider>
        )

    }
}

export default DashLayout;



// WEBPACK FOOTER //
// ./src/LayoutInvitee.js